import styles from './index.module.scss'
import DefaultPage from './components/DefaultPage'
import UploadInput from './components/UploadInput'
import { Drawer } from 'antd'
import SelectTryonPose from './components/SelectTryonPose'
import { useState, useRef, useContext, useEffect } from "react"
import API from "@api/api";
import { GenerateContext } from '../hooks/GenerateContext'
import MiddleComp from '../MiddleComp'
import { IMAGE_TYPE } from "@utils/CONST"
import { AppContext } from '@utils/AppContext'
import eventBus from "@utils/eventBus"

const FusionWear = () => {
    const { projectId, modelImage, setModelImage } = useContext(GenerateContext)
    const { setGlobalTaskReadFlag } = useContext(AppContext)
    const materialRef = useRef(null)
    const [drawOpen, setDrawOpen] = useState(false)
    const middleRef = useRef()
    const fusionWearRef = useRef(null)

    const handleReferenceChange = (value) => {
        setModelImage(value)
    }

    const handleOpenDrawer = () => {
        setDrawOpen(true)
    }

    const createClick = () => {
        // 触发侧边栏和中间页更新
        setGlobalTaskReadFlag(prev => !prev)
        if (middleRef.current) middleRef.current.fetchProjectDetail()
        if (fusionWearRef.current) fusionWearRef.current.scrollTop = 0
    }

    useEffect(() => {
        const handleFusionWearUpload = async (url) => {
            try {
                API.saveCustomTryOnModel({
                    tryOnImage: url,
                    thumbnail: url,
                    title: url.substring(url.lastIndexOf('/') + 1),
                    async: 1
                }).then((res) => {
                    if (res.code == 0) {
                        setModelImage([{
                            key: res.data?.id,
                            url,
                            custom: 1
                        }])
                    }
                })
            } catch (e) {
                console.error("Failed to process auto upload", e)
            }
        }
        eventBus.on("fusionWearAutoUpload", handleFusionWearUpload)
        return () => {
            eventBus.off("fusionWearAutoUpload", handleFusionWearUpload)
        }
    }, [])

    return (
        <div className={`${styles.FusionWear} _beauty_scrollbar`} ref={fusionWearRef} >
            <div className={styles.FusionWearWrap}>
                {
                    projectId ? <MiddleComp ref={middleRef} imageType={IMAGE_TYPE.FUSION_WEAR} /> : <DefaultPage />
                }
                <UploadInput
                    createClick={createClick}
                    containerRef={fusionWearRef}
                    modelImage={modelImage[0]?.url}
                    setModelImage={setModelImage}
                    handleOpenDrawer={handleOpenDrawer} />
                <div style={{ height: '300px', width: '100%' }}></div>
            </div>
            <Drawer
                closable={false}
                onClose={() => setDrawOpen(false)}
                open={drawOpen}
                width={1700}
                destroyOnHidden={true}
            >
                <SelectTryonPose
                    projectType='tryonBatch'
                    ref={materialRef}
                    setDrawOpen={setDrawOpen}
                    drawOpen={drawOpen}
                    maxCount={1}
                    value={modelImage}
                    onChange={handleReferenceChange}
                    onClose={() => setDrawOpen(false)}
                />
            </Drawer>
        </div>
    )
}


export default FusionWear
